import axios from "axios";
import qs from "qs";

import {api} from "@/plugins/util";

/**
 * 查询经办人列表(分页数据)
 * @param managerName   经办人名称
 * @returns {AxiosPromise<any>}
 */
export function getManagerList(current, managerName) {
    return axios.get(api + "/manager/getManagerList",
        {
            params: {
                current,
                managerName
            }
        })
}

/**
 * 获取经办人列表
 * @returns {AxiosPromise<any>}
 */
export function getManagerLists() {
    return axios.get(api + "/manager/getManagerLists", '');
}

/**
 * 主键查询
 * @param id
 * @returns {AxiosPromise<any>}
 */
export function getManagerByPrimaryKey(id) {
    return axios.get(api + "/manager/getManagerByPrimaryKey",
        {
            params: {
                id
            }
        })
}

/**
 * 添加经办人信息
 */
export function addManager(data) {
    return axios.post(api + "/manager/addManager", data);
}

/**
 * 修改经办人信息
 */
export function updateManager(data) {
    return axios.put(api + "/manager/updateManager", data);

}

/**
 * 删除经办人
 */
export function deleteManager(id) {
    return axios.delete(api + "/manager/deleteManager", {
        params: {
            id
        }
    })
}

/**
 * 上传身份证照片
 */
export function upLoadIdPhoto(data) {
    return axios({
        url: api + "/manager/upLoadIdPhoto",
        method: "post",
        data: data,
        headers: {"Content-Type": "application/x-www-form-urlencoded"}
    });
}